import api from '@/api/axios';

export const chargebeeOptin = async (): Promise<
  Response & { data: { message: string } | Error }
> => {
  return await api.post(`api/users/chargebee/optin`);
};
